import {Injectable} from '@angular/core';
import {BreakpointObserver} from "@angular/cdk/layout";
import {map, Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class MediaService {
  public get isMobile() {
    return this.breakpointObserver.isMatched('(max-width: 639px)');
  }

  public isMobile$: Observable<boolean> = this.breakpointObserver.observe(['(max-width: 639px)'])
    .pipe(map(res => res.matches));

  public get isSm() {
    return this.breakpointObserver.isMatched('(min-width: 640px)');
  }

  public isSm$: Observable<boolean> = this.breakpointObserver.observe(['(min-width: 640px)'])
    .pipe(map(res => res.matches));

  public get isMd() {
    return this.breakpointObserver.isMatched('(min-width: 768px)');
  }

  public isMd$: Observable<boolean> = this.breakpointObserver.observe(['(min-width: 768px)'])
    .pipe(map(res => res.matches));

  public get isUnderMd() {
    return this.breakpointObserver.isMatched('(max-width: 767px)');
  }

  public isUnderMd$: Observable<boolean> = this.breakpointObserver.observe(['(max-width: 767px)'])
    .pipe(map(res => res.matches));

  public get isLg() {
    return this.breakpointObserver.isMatched('(min-width: 1024px)');
  }

  public isLg$: Observable<boolean> = this.breakpointObserver.observe(['(min-width: 1024px)'])
    .pipe(map(res => res.matches));

  public get isXl() {
    return this.breakpointObserver.isMatched('(min-width: 1280px)');
  }

  public isXl$: Observable<boolean> = this.breakpointObserver.observe(['(min-width: 1280px)'])
    .pipe(map(res => res.matches));

  public get is2Xl() {
    return this.breakpointObserver.isMatched('(min-width: 1440px)');
  }

  public is2Xl$: Observable<boolean> = this.breakpointObserver.observe(['(min-width: 1440px)'])
    .pipe(map(res => res.matches));

  constructor(private breakpointObserver: BreakpointObserver
  ) {
  }
}
